import React from 'react';
import { useRouter, Redirect } from '@atlassian/react-resource-router';

export const TimelineRedirect = () => {
	const [{ query, match }] = useRouter();
	const queryParams = new URLSearchParams(query).toString();
	const { projectKey, boardId } = match.params;

	return (
		<Redirect
			to={{
				pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(
					boardId,
				)}/timeline`,
				hash: '',
				search: queryParams,
			}}
		/>
	);
};
